<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
<!--                <div class="mb-5 w-100">-->
<!--                    <button class="btn btn-primary float-right " @click="onLinkAndUnlinkClick">Link Or Unlink Customer To Discount Group</button>-->
<!--                </div>-->
                <data-table :headings="customerDiscountGroupsHeadings" :data="customerDiscountGroups" :hasActions="true"
                            :hasNoFilter="true"
                            :pagingDetails="pagingDetails"
                            :stateChanged="filterStateChanged"
                            @actionClicked="onCustomerDiscountGroupActionClicked"
                            @filterSearchClicked="onFilterSearchClicked">
                </data-table>
            </div>
        </div>
    </div>
<!--    <confirm-delete-modal-->
<!--        :elementId="customerDiscountUnlinkCustomerModal.modalId"-->
<!--        :message="customerDiscountUnlinkCustomerModal.message"-->
<!--        :showModal="customerDiscountUnlinkCustomerModal.showModal"-->
<!--        :loading="customerDiscountUnlinkCustomerModal.isSaving"-->
<!--        @deleteConfirmed="onConfirmUnlinkClick"></confirm-delete-modal>-->
    
<!--    <success-modal-->
<!--        :modalHeading="'Success'"-->
<!--        :elementId="'successModal'"-->
<!--        :modalMessage="successMessage"-->
<!--        :showModal="showSuccessMessage"-->
<!--        @okClicked="onSuccessModalOkClick"></success-modal>-->
<!--    -->
<!--    <error-modal-->
<!--            :modalHeading="'Error'"-->
<!--            :elementId="'errorModal'"-->
<!--            :modalMessage="errorMessage"-->
<!--            :showModal="showErrorMessage"-->
<!--            @okClicked="onErrorModalOkClick"></error-modal>-->
    
<!--    <link-unlink-customers-to-discount-group-->
<!--            :companyId="companyId"-->
<!--            :elementId="linkAndUnlinkDiscountGroupModal.modalId"-->
<!--            :showModal="linkAndUnlinkDiscountGroupModal.showModal"-->
<!--            @saveComplete="onLinkingSave"-->
<!--            @modalClose="onLinkAndUnlinkModalClose"></link-unlink-customers-to-discount-group>-->



    <div class="modal fade" id="viewDiscountGroupModal" tabindex="-1" role="dialog" aria-labelledby="viewDiscountGroupModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="viewDiscountGroupModalLabel">Discount Group</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onViewDiscountGroupModalClose">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="nameInput">
                            Name
                        </label>
                        <input type="text" class="form-control" id="nameInput" v-model="customerDiscountGroupAddEditForm.customerDiscountGroup.name.value" disabled/>
                    </div>
                    <div class="form-group">
                        <label for="discountAmountInput">
                            Price
                        </label>
                        <currency-input class="form-control" v-model="customerDiscountGroupAddEditForm.customerDiscountGroup.discountAmount.value"
                                        :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"
                                        :disabled="true"></currency-input>

                    </div>

                    <div>
                        <h5>Linked Products</h5>
                        <data-table
                                :headings="productsToLinkHeadings"
                                :data="customerDiscountGroupAddEditForm.customerDiscountGroup.linkedProducts.value"
                                :hasActions="false"
                                :hasCustomActionComponent="false"
                                :hasNoFilter="true"
                                :hasNoPaging="true">
                        </data-table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onViewDiscountGroupModalClose" :disabled="loading">CLOSE</button>
                </div>
            </div>
        </div>
    </div>
        
</div>
